import request from './request'

//获取个人信息
export function getPersonalData(data) {
  return request({
    url: 'myinfo',
    method: 'post',
    data
  })
}
//擅长领域
export function showType(data) {
  return request({
    url: 'getcatetory',
    method: 'post',
    data
  })
}

//获取地区
export function region(data) {
  return request({
    url: 'getcity',
    method: 'post',
    data
  })
}

//推广方式
export function pushrange(data) {
  return request({
    url: 'getpushchannel',
    method: 'post',
    data
  })
}

//编辑个人信息
export function editPersonal(data) {
  return request({
    url: 'savemyinfo',
    method: 'post',
    data
  })
}

// 修改头像
export function changeAvatar(data,header) {
  return request({
    url: '/pcportrait',
    method: 'post',
    data,
    header:header
  })
}